// CU-86d45b2z1 — deliberately not the staff <Layout>, which carries the clinical chrome and Xoe and relies on
// role checks to hide them; this shell renders only the allow-listed customer destinations.
import React, { ReactNode } from "react";

import CustomerSidebar from "./CustomerSidebar";
import CustomerTopBar from "./CustomerTopBar";
import { useSidebarCollapse } from "../layout/useSidebarCollapse";
import "../layout/Sidebar.css";

interface CustomerLayoutProps {
	children: ReactNode;
}

// CU-14ygtkj8nr3: a third key, so the customer rail never reads or overwrites the patient/staff choice; expanded by default.
const CUSTOMER_COLLAPSE_KEY = "mg-customer-sidebar-collapsed";

const CustomerLayout: React.FC<CustomerLayoutProps> = ({ children }) => {
	const [collapsed, setCollapsed] = useSidebarCollapse(CUSTOMER_COLLAPSE_KEY, false);

	const contentClass = ["mg-layout-content", collapsed ? "sidebar-collapsed" : ""].filter(Boolean).join(" ");

	return (
		<div style={{ position: "relative", minHeight: "100vh" }} data-testid="customer-shell">
			<CustomerSidebar collapsed={collapsed} onCollapse={setCollapsed} />
			<CustomerTopBar collapsed={collapsed} />
			<main className={contentClass}>{children}</main>
		</div>
	);
};

export default CustomerLayout;
